import { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { REGIONS, COUNTRY_REGION } from "../../data/content";

const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";
const COLOR = Object.fromEntries(REGIONS.map((r) => [r.name, r.color]));
const BASE = "#222a36";
const DIM = "#2b3340";
const PROJECTION_CONFIG = { scale: 168 };

export const InteractiveMap = () => {
  const [active, setActive] = useState(null);
  const [tip, setTip] = useState(null);

  const toggle = (region) => setActive((a) => (a === region ? null : region));

  const fillFor = (name) => {
    const region = COUNTRY_REGION[name];
    if (!region) return BASE;
    if (active && region !== active) return DIM;
    return COLOR[region];
  };

  return (
    <div className="map-section-inner">
      <div>
        <div className="imap-wrap dark-zone" onMouseLeave={() => setTip(null)}>
          <ComposableMap
            projection="geoEqualEarth"
            projectionConfig={PROJECTION_CONFIG}
            width={900}
            height={420}
            data-testid="coverage-map"
          >
            <Geographies geography={GEO_URL}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const name = geo.properties.name;
                  const region = COUNTRY_REGION[name];
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      onMouseMove={(e) =>
                        region && setTip({ name, region, x: e.clientX, y: e.clientY })
                      }
                      onMouseLeave={() => setTip(null)}
                      onClick={() => region && toggle(region)}
                      style={{
                        default: { fill: fillFor(name), stroke: "#0d1117", strokeWidth: 0.4, outline: "none" },
                        hover: {
                          fill: region ? COLOR[region] : BASE,
                          stroke: "#0d1117", strokeWidth: 0.6, outline: "none",
                          cursor: region ? "pointer" : "default",
                        },
                        pressed: { fill: region ? COLOR[region] : BASE, outline: "none" },
                      }}
                    />
                  );
                })
              }
            </Geographies>
          </ComposableMap>
          {tip && (
            <div className="imap-tooltip" style={{ left: tip.x, top: tip.y }}>
              <strong>{tip.name}</strong>
              <span>{tip.region}</span>
            </div>
          )}
        </div>
        <div className="imap-hint">
          <span>Hover a highlighted country · click a region to filter</span>
          {active && (
            <button className="imap-reset" onClick={() => setActive(null)} data-testid="map-reset">
              Reset ✕
            </button>
          )}
        </div>
      </div>

      <div className="map-legend">
        {REGIONS.map((r) => (
          <button
            key={r.name}
            className={`map-legend-item legend-btn ${active === r.name ? "active" : ""} ${active && active !== r.name ? "dim" : ""}`}
            onClick={() => toggle(r.name)}
            data-testid={`region-filter-${r.name}`}
          >
            <div className="map-dot" style={{ background: r.color }} aria-hidden="true" />
            <div className="map-region">{r.name}</div>
            <div className="map-count">{r.count}</div>
          </button>
        ))}
        <div className="map-legend-item" style={{ borderColor: "var(--primary)" }}>
          <div className="map-dot" style={{ background: "linear-gradient(135deg,var(--primary),var(--accent-teal))" }} aria-hidden="true" />
          <div className="map-region"><strong>Total Coverage</strong></div>
          <div className="map-count" style={{ color: "var(--primary)" }}>73</div>
        </div>
      </div>
    </div>
  );
};
